import React from 'react';
import { Modal, Table } from 'antd';
import { useTranslation } from 'react-i18next';

/**
 * 搜尋結果選擇 Modal
 * 當掃描到多筆結果時（tracking_number 循環使用、fulfillment name 重複），
 * 讓操作員從列表中選擇正確的結果。
 */
function ResultSelectModal({ open, results, matchType, onSelect, onCancel }) {
  const { t } = useTranslation();

  const columns = [
    {
      title: t('operator.return_verification.result_select.merchant', { defaultValue: '貨主' }),
      dataIndex: ['merchant', 'name'],
      key: 'merchant',
      width: 120,
    },
    {
      title: t('operator.return_verification.result_select.fulfillment', { defaultValue: '出貨單' }),
      key: 'fulfillment',
      width: 150,
      render: (_, record) => record.fulfillment?.number || record.fulfillment?.name || '-',
    },
    {
      title: t('operator.return_verification.result_select.orders', { defaultValue: '訂單' }),
      key: 'orders',
      width: 150,
      render: (_, record) => record.orders?.map(o => o.name).join(', ') || '-',
    },
    {
      title: t('operator.return_verification.result_select.tracking', { defaultValue: '物流單號' }),
      key: 'tracking',
      width: 150,
      render: (_, record) => record.shipments?.map(s => s.tracking_number).filter(Boolean).join(', ') || '-',
    },
    {
      title: t('operator.return_verification.result_select.status', { defaultValue: '出貨狀態' }),
      key: 'status',
      width: 100,
      render: (_, record) => record.fulfillment?.status || '-',
    },
    {
      title: t('operator.return_verification.result_select.items', { defaultValue: '品項數' }),
      key: 'items',
      width: 80,
      render: (_, record) => record.items?.length || 0,
    },
  ];

  return (
    <Modal
      open={open}
      title={t('operator.return_verification.result_select.title', {
        defaultValue: '找到多筆結果，請選擇',
      })}
      onCancel={onCancel}
      footer={null}
      width={800}
    >
      <Table
        columns={columns}
        dataSource={results}
        rowKey={(record) => record.fulfillment?.id || record.return_order?.id || record.existing_return_order?.id}
        pagination={false}
        size="small"
        onRow={(record) => ({
          onClick: () => onSelect(record),
          style: { cursor: 'pointer' },
        })}
      />
    </Modal>
  );
}

export default ResultSelectModal;
